import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/* Powrót do Friday z widoków sekcji „Postęp prac" (wcześniej osobne pozycje
   menu — zob. useWorkProgressLinks). WorkProgressSection dokleja `?from=`, więc
   wracamy dokładnie do tego widoku Friday, z którego użytkownik wyszedł.
   Nieznane/obce `from` ignorujemy — inaczej parametr z URL-a sterowałby
   nawigacją w dowolne miejsce. */

const FRIDAY_VIEWS: Record<string, string> = {
  "/tasks/board": "Friday — tablica",
  "/tasks/list": "Friday — lista",
};

const DEFAULT_VIEW = "/tasks/board";

export function BackToFridayLink({ className }: { className?: string }) {
  const [params] = useSearchParams();
  const from = params.get("from") ?? "";
  const to = FRIDAY_VIEWS[from] ? from : DEFAULT_VIEW;

  return (
    <Link
      to={to}
      className={`inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-[var(--color-primary)] transition-colors ${className ?? ""}`}
    >
      <ArrowLeft size={15} />
      {FRIDAY_VIEWS[to]}
    </Link>
  );
}
